import { Component, OnInit } from '@angular/core';
import { PatientjourneyService } from '../../_service/patientjourney.service';
import { SharedService } from '../../_service/shared.service';
import {MatDialog} from '@angular/material/dialog';


@Component({
  selector: 'app-today-admission-today-discharge',
  templateUrl: './today-admission-today-discharge.component.html',
  styleUrls: ['./today-admission-today-discharge.component.css']
})
export class TodayAdmissionTodayDischargeComponent implements OnInit {

  constructor(private sharedapi:SharedService, private dialog:MatDialog,private patientjourneyapi:PatientjourneyService) { }
  todayAdmissionIpdData:any=[];todayDischargeIpdData:any=[];loaded:boolean=false;loading:boolean=true;
  ngOnInit(): void {
  }
  ngAfterViewInit() {
    this.loadData();
  }

  async loadData()
  {
      
      let qString = '';
      this.loading = true;
      this.loaded = false;
      this.patientjourneyapi.getTodayPatientjourneyList(qString).subscribe((data:any) => {
        this.loading = false;
        this.loaded = true;
        if(data.status)
        {
            this.todayAdmissionIpdData = data.data.today_admission_ipds;
            this.todayDischargeIpdData = data.data.today_discharge_ipds;
        }else{
            this.todayAdmissionIpdData = [];
            this.sharedapi.presentToast(data.msg);
        }
      }, error => {
          this.loading = false;
          this.loaded = true;
          this.sharedapi.checkError(error);
      });
  }
}
